<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg || this.internalErrorMessage"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-date-complex-base
            [formControl]="control"
            [id]="controlId"
            [min]="min || null"
            [max]="max || null"
            [invalid]="isControlInvalid$ | async"
            [required]="isControlRequired$ | async"
            [autocomplete]="autocomplete"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            class="sh-form-group__input"
            [indeterminateMsg]="indeterminateMsg"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            (validationChange)="handleValidation($event)"
        >
        </sh-form-date-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-date-base
            [formControl]="control"
            [id]="controlId"
            [min]="min || null"
            [max]="max || null"
            [invalid]="isControlInvalid$ | async"
            [required]="isControlRequired$ | async"
            [autocomplete]="autocomplete"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            class="sh-form-group__input"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            (validationChange)="handleValidation($event)"
        >
        </sh-form-date-base>
    </ng-template>
</sh-form-group>
